import { render, staticRenderFns } from "./FiatSection.vue?vue&type=template&id=cb509ea2&scoped=true"
import script from "./FiatSection.vue?vue&type=script&lang=js"
export * from "./FiatSection.vue?vue&type=script&lang=js"
import style0 from "./FiatSection.vue?vue&type=style&index=0&id=cb509ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb509ea2",
  null
  
)

export default component.exports